import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

// eslint-disable-next-line @typescript-eslint/unbound-method -- This is the recommended way to create multi-style configs in Chakra UI
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(menuAnatomy.keys);

const MenuTheme = defineMultiStyleConfig({
  baseStyle: {
    list: {
      overflow: 'hidden',
      borderRadius: '6px',
      borderColor: 'rgba(20, 20, 20, 0.1)',
      boxShadow: '0 20px 48px rgba(0, 0, 0, 0.18)',
    },
    item: {
      color: '#000',
      fontSize: '12px',
      fontWeight: 500,
      transition: 'all 0.2s ease',
      _hover: {
        bg: '#f2f2f2',
      },
    },
    button: {
      bg: 'transparent',
    },
  },
});

export default MenuTheme;
